import converterTagHtml from "../../../helpers/converterTagHtml";

import styled, { keyframes } from "styled-components";
const NewsPage = (props) => {
  const { dataNews, totalPageCount, isHovering, setIsHovering } = props;
  const aniHoveringBtn1 = keyframes`
  from{
    transform: translate3d(0px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); 
    transform-style: preserve-3d; 
    opacity: 1; 
  }
  to{
    transform: translate3d(32px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); 
    transform-style: preserve-3d; 
    opacity: 0;
  }
  `;
  const aniHoveringBtn2 = keyframes`
  from{
    transform: translate3d(-30px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); 
    transform-style: preserve-3d; 
    opacity: 0; 
  }
  to{
    transform: translate3d(10px, 0px, 0px) scale3d(1, 1, 1) rotateX(0deg) rotateY(0deg) rotateZ(0deg) skew(0deg, 0deg); 
    transform-style: preserve-3d; 
    opacity: 1;
  
  }
  `;
  const Rotate = styled.div`
    animation: ${aniHoveringBtn1} 0.5s ease-in-out 1 alternate-reverse;
  `;
  const Rotate2 = styled.div`
    animation: ${aniHoveringBtn2} 0.5s ease-in-out;
  `;
  return (
    <>
      {/* modified template into tailwind layout css */}
      <div className="pt-40 desktop:pt-10 pb-12 bg-[#212121] bg-[url('https://images.unsplash.com/photo-1593789198777-f29bc259780e?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1170&q=80')] bg-p   desktop:bg-[center_top_5rem] bg-contain bg-no-repeat img-blog overflow-hidden relative">
        <div className="max-w-[1200px] flex mx-auto relative  ">
          <div className=" flex flex-col desktop:flex-1 desktop:w-full desktop:items-center px-6 mb-12 w-[61%]">
            <div className="text-sm font-bold font1   mb-12  text-[#777] ">
              <a href="/">
                <span className="text-blueLink">Home</span>
              </a>
              <span class="fa mx-2 text-[9px]"></span>
              News
            </div>
            <div className="px-[40px] py-[64px] bg-white desktop:bg-transparent  ">
              <div className="c-gridpost__category mb-4 text-[11px] font-semibold uppercase tracking-widest ">
                <a className="text-blueLink" href="#">
                  Design
                </a>
                <span> / </span>
                <a className="text-blueLink" href="#">
                  Technology
                </a>
              </div>
              <a
                href="single-post.html"
                className=" text-[#212121] inline-block"
              >
                <h1 className="font2 text-[#333] desktop:text-[#fff] desktop:font-light text-[52px] leading-[1.15] font-semibold mb-2">
                  How Influencer Marketing Needs to be Decentralized
                </h1>
                <div className="mb-6 text-2xl desktop:text-[#fff] desktop:font-light font1 leading-[1.4]">
                  As influencer marketing on YouTube and Instagram likely peaked
                  in 2020, micro influencers are seeking new channels to grow
                  more organically and earn a side income.
                </div>
              </a>
              <a
                href="single-post.html"
                className="cta-link align-middle font3 text-blueLink text-xs font-bold uppercase"
                onMouseEnter={() => setIsHovering(-2)}
                onMouseLeave={() => setIsHovering(-1)}
              >
                <span className="align-middle mr-12">Read more</span>
                <span
                  className={
                    isHovering === -2
                      ? "inline-block align-middle self-center text-[17px] text-blueLink c-cta1_arrow-hovered"
                      : "inline-block align-middle self-center text-[10px] text-blueLink c-cta1__arrow-normal"
                  }
                >
                  {isHovering === -2 ? (
                    <Rotate2></Rotate2>
                  ) : (
                    <Rotate></Rotate>
                  )}
                </span>
              </a>
            </div>
          </div>
          <div className="flex desktop:flex-col desktop:w-full w-[43.45%] lg-5 px-12 mb-0" />
        </div>
        <div className="desktop:block desktop:bg-black" />
      </div>
      <div className="pt-24 pb-12">
        <div className="container max-w-[1200px] mx-auto relative px-4  ">
          <div className="grid grid-cols-3  desktop:grid-cols-1 gap-x-12">
            {dataNews?.map((data, index) => (
              <div className="mb-24" key={index}>
                <a href="single-post.html" className="max-w-full inline-block">
                  <img src={data.post_image} alt="" className="mb-6" />
                </a>
                <div className="c-gridpost__category mb-4 text-[11px] font-semibold uppercase tracking-widest">
                  <a className="text-blueLink" href="#">
                    design
                  </a>
                  <span> / </span>
                  <a className="text-blueLink" href="#">
                    technology
                  </a>
                </div>
                <h3 className="mb-2 font2 text-2xl leading-6 font-black">
                  {data.post_title}
                </h3>
                <div className="mb-6 font1  text-base leading-6">
                  {converterTagHtml(data?.post_content)}
                </div>
                <a
                  href={`news/${data.slug}`}
                  className="align-center font3 text-blueLink text-xs font-bold uppercase"
                >
                  <a
                    href="single-post.html"
                    className="cta-link align-middle font3 text-blueLink text-xs font-bold uppercase"
                    // onMouseEnter={() => setIsHovering(index)}
                    // onMouseLeave={() => setIsHovering(-1)}
                  >
                  </a>
                </a>
              </div>
            ))}
          </div>
        </div>

        {/* <div className="container max-w-[1200px] mx-auto">
          <div className="mb-12 ">
            <div className="text-2xl"> / {totalPageCount}</div>
            <Pagination />
          </div>
        </div> */}
      </div>
    </>
  );
};

export default NewsPage;
